import { DeletePopupComponent } from "src/app/components/delete-popup/delete-popup.component";
import {
  GenericPopupComponent,
  PopupButton,
} from "src/app/components/generic-popup/generic-popup.component";
import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxDataGridModule,
  DxFormModule,
  DxLookupModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxSwitchModule,
  DxTextBoxComponent,
  DxTextBoxModule,
  DxToastModule,
  DxToolbarModule,
  DxValidatorModule,
} from "devextreme-angular";
import { ConfigService } from "src/app/services/config.service";
import { DataAccessService } from "src/app/services/data-access.service";
import { DxoLookupModule } from "devextreme-angular/ui/nested";
import { AppGlobals } from "src/app/app.globals";
import { environment } from "src/environments/environment";
import {
  EditingStartEvent,
  SavedEvent,
  SavingEvent,
} from "devextreme/ui/data_grid";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";

import { ActivityLogService } from "src/app/services/activity-log.service";
import { ActivitySection } from "src/app/constants/activity-log";
import { SearchableDropdownDirective } from '../../../directives/searchable-dropdown.directive';
import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
@Component({
    selector: "app-config-user-permissions",
    imports: [
    SvgIconComponent,
        CommonModule,
        DxDataGridModule,
        DxToastModule,
        DxFormModule,
        DxToolbarModule,
        DeletePopupComponent,
        GenericPopupComponent,
        DxButtonModule,
        DxoLookupModule,
        DxPopupModule,
        DxCheckBoxModule,
        DxSelectBoxModule,
        DxTextBoxModule,
        DxValidatorModule,
        GpdButtonComponent,
        SearchableDropdownDirective
    ],
    templateUrl: "./config-user-permissions.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./config-user-permissions.component.css"]
})
export class ConfigUserPermissionComponent implements OnInit {
  userWiEnergyEntraOid: any = "";

  type: any = "";
  message: any = "";
  toastVisible: boolean = false;

  dataGridHeight: any = "90%";

  currentSelection: any = $localize`:@@currentSelection:Current Selection:`;

  @ViewChild("userGrid") userRolesGrid: any;
  @ViewChild("newUserGrid") newUserGrid: any;

  searchValue: any;
  searchFilter: any;

  deletePopupVisible: any;
  showProjectList: boolean = false;
  popupWidth: number = null;
  popupHeight: string = "auto";
  popupMaxHeight = "80vh";
  isGridVisible: boolean = false;
  confirmationMessage: string = "";
  affectedProjectsList: any = [];
  affectedDeadlinesList: any[] = [];
  hasDeadlines: boolean = false;
  // #1949: a restricted contract is invisible to administrators, so deleting its owner is the
  // only chance to hand it on - the deletion is blocked until a successor is chosen.
  ownedContractsList: any[] = [];
  hasOwnedContracts: boolean = false;
  // #1016: dynamic tables the user owns and others use - the project successor takes them over
  sharedTablesList: { title: string }[] = [];
  hasSharedTables: boolean = false;
  // #4938: task rules that name the user (fixed recipient or assignee) - the rule successor takes their place
  affectedRulesList: { ruleName: string; taskTitle: string }[] = [];
  hasRules: boolean = false;
  successorOptions: any[] = [];
  projectSuccessor: string = null;
  deadlineSuccessor: string = null;
  contractSuccessor: string = null;
  ruleSuccessor: string = null;

  deleteUserPopupTitle = $localize`:@@deleteUser:Delete User`;

  get projectDeleteButtons(): PopupButton[] {
    return [
      {
        text: $localize`:@@cancel:Cancel`,
        type: "tertiary-text",
        onClick: () => {
          this.showProjectList = false;
        },
      },
      {
        text: $localize`:@@delete:Delete`,
        type: "danger",
        disabled:
          ((this.isGridVisible || this.hasSharedTables) && !this.projectSuccessor) ||
          (this.hasDeadlines && !this.deadlineSuccessor) ||
          (this.hasOwnedContracts && !this.contractSuccessor) ||
          (this.hasRules && !this.ruleSuccessor),
        onClick: () => this.onConfirm(null),
      },
    ];
  }
  users: any;
  // #4992: a user belongs to at most one department
  departments: any[] = [];
  usersFromAzure = [];
  listOfUsers = [];

  newId = 0;

  roles = [
    { id: "Administration", name: $localize`:@@administrator:Administrator` },
    { id: "Mitarbeiter", name: $localize`:@@mitarbeiter:Mitarbeiter` },
    { id: "EPC", name: $localize`:@@epc:EPC` },
    { id: "Partner", name: $localize`:@@partner:Partner` },
  ];

  popupVisible = false;

  newUser = {
    id: null,
    firstName: null,
    lastName: null,
    displayName: null,
    emailAddress: null,
    role: null,
    userRights: null,
    userRightsId: null,
    canView: false,
    canEdit: false,
    canComplete: false,
    canValidate: false,
    canDelete: false,
    wiEnergyEntraOid: null,
    reportsToEmail: null,
    departmentId: null,
  };

  userToDelete: any;
  pageBreadCrumb: any = {
    text: $localize`Configuration/`,
    href: window.location.href,
    layer: 0,
  };

  userRightsList: any = [
    { id: 1, text: $localize`:@@canViewUserPermission:Can View` },
    { id: 2, text: $localize`:@@canEditUserPermission:Can Edit` },
    { id: 3, text: $localize`:@@completeTaskUserPermission:Complete Task` },
    { id: 4, text: $localize`:@@validateTaskUserPermission:Validate Task` },
    { id: 5, text: $localize`:@@canDeleteUserPermission:Can Delete` },
  ];

  selectedItem: any = {};

  addSelectBoxVisible: boolean = false;

  constructor(
    private service: ConfigService,
    private appGlobals: AppGlobals,
    private activityLog: ActivityLogService,
    private dataAccessService: DataAccessService
  ) {}

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_USERS });
    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
    AppGlobals.clearBreadCrumbInLocalStorage();
    this.getPageData();
  }

  getPageData() {
    this.dataAccessService.loadDepartments().then((departments) => (this.departments = departments));
    this.service.getListOfUsers({}).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.users = result.projectsUsers;
          this.listOfUsers = result.projectsUsers;
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  addNewRow(e) {
    this.popupVisible = true;
  }

  initDeleteUser(e, item) {
    this.userToDelete = item.data;
    this.deletePopupVisible = true;
    this.message =
      $localize`:@@deleteUser:delete user` + ` ${item.data.displayName}?`;
  }

  initEditUser(e, item) {
    this.userRolesGrid.instance.editRow(item.rowIndex);
  }

  onAbort(e) {
    this.deletePopupVisible = false;
  }

  onConfirm(e) {
    this.showProjectList = false;
    this.service
      .deleteUser({
        projectsUser: this.itemData,
        projectSuccessorEmail: this.projectSuccessor,
        deadlineSuccessorEmail: this.deadlineSuccessor,
        contractSuccessorEmail: this.contractSuccessor,
        ruleSuccessorEmail: this.ruleSuccessor,
      })
      .then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.getPageData();
            this.saveToast({ type: true, feedback: $localize`Deleted` });
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    // }

    this.deletePopupVisible = false;
    this.isGridVisible = false;
  }

  email: string = "";
  itemData: any = {};
  confirmDelete(e: any, item: any): void {
    this.itemData = item;
    this.userWiEnergyEntraOid = item.wiEnergyEntraOid;
    this.email = item.emailAddress;
    this.userToDelete = {
      ProjectsUser: {
        WIEnergyEntraOid: this.userWiEnergyEntraOid,
        EmailAddress: this.email,
      },
    };

    this.service.confirmDeleteUser(this.userToDelete).then((result: any) => {
      const projects =
        result.affectedProjects?.map((project: any) => project.pva) || [];
      this.isGridVisible = projects.length > 0;
      this.affectedDeadlinesList = result.affectedDeadlines || [];
      this.hasDeadlines = this.affectedDeadlinesList.length > 0;
      this.ownedContractsList = result.ownedContracts || [];
      this.hasOwnedContracts = this.ownedContractsList.length > 0;
      this.sharedTablesList = (result.ownedSharedTables || []).map((title: string) => ({ title }));
      this.hasSharedTables = this.sharedTablesList.length > 0;
      this.affectedRulesList = result.affectedRules || [];
      this.hasRules = this.affectedRulesList.length > 0;

      // popup needs more room when any list or picker is shown
      this.popupWidth =
        this.isGridVisible || this.hasDeadlines || this.hasOwnedContracts || this.hasSharedTables || this.hasRules ? 900 : 400;
      this.confirmationMessage = this.buildConfirmationMessage();

      // Format the projects for a two-column display
      this.affectedProjectsList = [];
      for (let i = 0; i < projects.length; i += 2) {
        this.affectedProjectsList.push({
          projectName1: projects[i],
          projectName2: projects[i + 1] || "", // Handle odd number of projects
        });
      }

      // successor choices = all users except the one being deleted
      this.successorOptions = (this.users || []).filter(
        (u: any) => u.emailAddress !== this.email
      );
      this.projectSuccessor = null;
      this.deadlineSuccessor = null;
      this.contractSuccessor = null;
      this.ruleSuccessor = null;

      // only open the popup once its size/content are known, otherwise the
      // underlying dx-popup renders at its initial (small) size and never resizes
      this.showProjectList = true;
    });
  }

  private escapeHtml(text: string): string {
    return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  private buildConfirmationMessage(): string {
    const rawName =
      this.itemData?.displayName || this.itemData?.emailAddress || "";
    const userName = rawName ? `<strong>${this.escapeHtml(rawName)}</strong>` : "";

    // ponytail: one message that names whatever is blocking, rather than a branch per
    // combination - a third blocker (#1949) would otherwise have meant seven of them.
    const blockers: string[] = [];
    if (this.isGridVisible) blockers.push($localize`:@@blockerProjects:active projects`);
    if (this.hasDeadlines) blockers.push($localize`:@@blockerDeadlines:upcoming contract deadlines`);
    if (this.hasOwnedContracts) blockers.push($localize`:@@blockerOwnedContracts:contracts they own`);
    if (this.hasSharedTables) blockers.push($localize`:@@blockerSharedTables:tables they share with others`);
    if (this.hasRules) blockers.push($localize`:@@blockerRules:task rules that name them`);

    if (!blockers.length) {
      return $localize`:@@deleteConfirm:Are you sure you want to delete ${userName}?`;
    }

    const blockerList = blockers.join(", ");
    return $localize`:@@deleteBlockedBy:${userName} can't be deleted yet - they're still linked to ${blockerList}. Choose a successor for each to continue.`;
  }

  saveToast(e: any): void {
    const type = e.type ? "success" : "error";
    if ((this.type = "success")) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage(
        $localize`:@@errorTryAgain:ERROR: There was an error, please try again.`
      );
    }
    this.type = type;
    this.toastVisible = true;
  }

  saveChanges(user) {
    this.service.writeUsers({ ProjectsUser: user }).then(
      (result) => {
        if (result.hasError === true)
          AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
          this.getPageData();
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  initializeAddingRow(e) {
    this.resetFilters();

    this.newUser = {
      id: null,
      firstName: null,
      lastName: null,
      displayName: null,
      emailAddress: null,
      role: null,
      userRights: null,
      userRightsId: null,
      canView: false,
      canEdit: false,
      canComplete: false,
      canValidate: false,
      canDelete: false,
      wiEnergyEntraOid: null,
      reportsToEmail: null,
      departmentId: null,
    };
  }

  resetFilters() {
    this.searchValue = "";
  }

  saveNewUser(e: any): void {
    e.preventDefault();
    this.writeNewUserPermission();
  }

  // #465: a double click or a second Enter would post the same user twice while the first
  // request is still on its way - both would pass the API's duplicate check.
  savingNewUser = false;

  writeNewUserPermission(): void {
    if (this.savingNewUser) return;
    let newUser = {
      ProjectsUser: {
        WIEnergyEntraOid: this.newUser.wiEnergyEntraOid,
        FirstName: this.newUser.firstName,
        LastName: this.newUser.lastName,
        EmailAddress: this.newUser.emailAddress,
        UserRole: this.newUser.role,
        UserRights: this.newUser.userRights,
        UserRightsId: this.newUser.userRightsId,
        CanEdit: this.newUser.canEdit,
        CanView: this.newUser.canView,
        CanComplete: this.newUser.canComplete,
        CanValidate: this.newUser.canValidate,
        CanDelete: this.newUser.canDelete,
        ReportsToEmail: this.newUser.reportsToEmail,
        DepartmentId: this.newUser.departmentId,
      },
    };

    this.savingNewUser = true;
    this.service
      .writeUsers(newUser)
      .then(
        (result) => {
          if (result.hasError === true)
            AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.popupVisible = false;
            this.saveToast({
              type: true,
              feedback: $localize`:@@success:Success`,
            });
            this.getPageData();
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      )
      .finally(() => (this.savingNewUser = false));
  }

  abortSelection(e) {
    this.popupVisible = false;
  }

  onCellPrepared(e) {
    if (this.searchValue) {
      let title = e.displayValue;
      if (title != null) {
        let index = title.toLowerCase().indexOf(this.searchValue.toLowerCase());
        if (index != -1) {
          let match = title.slice(index, index + this.searchValue.length);
          var searchMatchString =
            "<span class='search-text'>" + match + "</span>";
          title = title.split(match).join(searchMatchString);
          var result = "<div>" + title + "</div>";
          e.cellElement.innerHTML = result;
        }
      }
    }
  }

  searchValueChanged(e) {
    this.searchValue = e.value;
    this.searchFilter = [
      ["firstname", "contains", this.searchValue],
      "or",
      ["lastname", "contains", this.searchValue],
      "or",
      ["emailAddress", "contains", this.searchValue],
    ];
    this.applyFilter();
  }

  applyFilter() {
    this.userRolesGrid.instance.filter([this.searchFilter]);
  }

  changeUserPermissions(e: any, item): void {
    item.setValue(e.value);
    if (e.value === 1) {
      item.data.canView = true;
      item.data.canEdit = false;
      item.data.canComplete = false;
      item.data.canValidate = false;
      item.data.canDelete = false;
    }

    if (e.value === 2) {
      item.data.canView = true;
      item.data.canEdit = true;
      item.data.canComplete = false;
      item.data.canValidate = false;
      item.data.canDelete = false;
    }

    if (e.value === 3) {
      item.data.canView = true;
      item.data.canEdit = true;
      item.data.canComplete = true;
      item.data.canValidate = false;
      item.data.canDelete = false;
    }

    if (e.value === 4) {
      item.data.canView = true;
      item.data.canEdit = true;
      item.data.canComplete = true;
      item.data.canValidate = true;
      item.data.canDelete = false;
    }

    if (e.value === 5) {
      item.data.canView = true;
      item.data.canEdit = true;
      item.data.canComplete = true;
      item.data.canValidate = true;
      item.data.canDelete = true;
    }
  }

  changeNewUserPermissions(e: any, item: any): void {
    this.newUser.userRightsId = e.value;

    if (e.value === 1) {
      this.newUser.userRights = $localize`:@@view:View`;
      this.newUser.canView = true;
      this.newUser.canEdit = false;
      this.newUser.canComplete = false;
      this.newUser.canValidate = false;
      this.newUser.canDelete = false;
    }

    if (e.value === 2) {
      this.newUser.userRights = $localize`:@@edit:Edit`;
      this.newUser.canView = true;
      this.newUser.canEdit = true;
      this.newUser.canComplete = false;
      this.newUser.canValidate = false;
      this.newUser.canDelete = false;
    }

    if (e.value === 3) {
      this.newUser.userRights = $localize`:@@complete:Complete`;
      this.newUser.canView = true;
      this.newUser.canEdit = true;
      this.newUser.canComplete = true;
      this.newUser.canValidate = false;
      this.newUser.canDelete = false;
    }

    if (e.value === 4) {
      this.newUser.userRights = $localize`:@@validate:Validate`;
      this.newUser.canView = true;
      this.newUser.canEdit = true;
      this.newUser.canComplete = true;
      this.newUser.canValidate = true;
      this.newUser.canDelete = false;
    }

    if (e.value === 5) {
      this.newUser.userRights = $localize`:@@delete:Delete`;
      this.newUser.canView = true;
      this.newUser.canEdit = true;
      this.newUser.canComplete = true;
      this.newUser.canValidate = true;
      this.newUser.canDelete = true;
    }
  }

  saveUser(e) {
    this.saveChanges(e.data);
  }
}
